import styles from "./PortalFooter.module.css";
import { useLanguage } from "../LanguageContext";

// `cta` lets a page swap the free-user banner copy: { title, highlight, desc, mobileDesc, button, onClick }
export default function PortalFooter({ onNavigate, isFunded, onGetFunded, cta }) {
  const { t } = useLanguage();
  const banner = {
    title: t("footer_cta_title"),
    highlight: t("footer_cta_highlight"),
    desc: t("footer_cta_desc"),
    button: t("footer_cta_btn"),
    onClick: onGetFunded,
    ...cta,
  };
  return (
    <footer className={styles.footer}>
      {!isFunded && (
        <div className={`${styles.ctaBanner} d-flex align-items-center justify-content-between`}>
          <div>
            <h2 className={styles.ctaTitle}>
              {banner.title} <span className={styles.ctaHighlight}>{banner.highlight}</span>
            </h2>
            <p className={`${styles.ctaDesc} ${banner.mobileDesc ? styles.ctaDescDesktop : ""}`}>{banner.desc}</p>
            {banner.mobileDesc && (
              <p className={`${styles.ctaDesc} ${styles.ctaDescMobile}`}>{banner.mobileDesc}</p>
            )}
          </div>
          <button type="button" className={styles.ctaBtn} onClick={banner.onClick}>
            {banner.button}
          </button>
        </div>
      )}

      <div className={`${styles.footerRow} d-flex`}>
        <div className={`${styles.statusPill} d-inline-flex align-items-center`}>
          <span className={styles.statusDot} aria-hidden="true" />
          <span>{t("footer_online")}</span>
        </div>

        <nav className={`${styles.links} d-flex align-items-center`} aria-label="Footer navigation">
          {[
            { path: "https://docs.propfunding.com", labelKey: "footer_docs", external: true },
            { path: "https://discord.com/invite/8z37khrMA6", labelKey: "footer_support", external: true },
            { path: "https://propfunding.com/terms", labelKey: "footer_terms", external: true },
            { path: "https://propfunding.com/privacy-policy", labelKey: "footer_privacy", external: true },
          ].map((item, index) => (
            <span key={item.labelKey} className={`${styles.linkItem} d-inline-flex align-items-center`}>
              {index > 0 ? <span className={styles.separator}>•</span> : null}
              <a
                href={item.path}
                {...(item.external && { target: "_blank", rel: "noopener noreferrer" })}
                onClick={(event) => {
                  if (!item.external) {
                    event.preventDefault();
                    onNavigate(item.path);
                  }
                }}
              >
                {t(item.labelKey)}
              </a>
            </span>
          ))}
        </nav>
      </div>
    </footer>
  );
}
